import { render, staticRenderFns } from "./SolutionTypeEdit.vue?vue&type=template&id=0338a81b&scoped=true&"
import script from "./SolutionTypeEdit.vue?vue&type=script&lang=js&"
export * from "./SolutionTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338a81b",
  null
  
)

export default component.exports